import { render, staticRenderFns } from "./WebFrame.vue?vue&type=template&id=4373f81c"
import script from "./WebFrame.vue?vue&type=script&lang=js"
export * from "./WebFrame.vue?vue&type=script&lang=js"
import style0 from "./WebFrame.vue?vue&type=style&index=0&id=4373f81c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports